"use client";

import type { ComponentInfo, RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

const REGION_SELECTOR_INPUTS = [
  {
    name: "selectedRegion",
    type: "string",
    defaultValue: "",
    required: true,
  },
] as const satisfies ComponentInfo["inputs"];

export const RegionSelectorComponent: RegisteredComponent = {
  name: "Region selector",
  component: dynamic(async () => (await import("./RegionSelector")).RegionSelector),
  models: [getBuilderModelName("category")],
  defaults: {
    bindings: {
      selectedRegion: "selectedRegion",
    },
  },
  inputs: REGION_SELECTOR_INPUTS,
};

export type RegionSelectorProps = BuilderComponentProps<typeof REGION_SELECTOR_INPUTS>;
